import React, { useState, useEffect } from "react";
import Select from "react-select";
import PlanCard from "../../components/planCard/planCard";
import Loader from "../../components/loader/loader";
import { tWithKeyAttr as t } from "../../i18nHelper";
import styles from "./companyOnboading.module.css";
import formStyles from "../../components/forms/forms.module.css";
import { TPlan } from "../../services/types/utils.types";
import { TPaymentPeriodType } from "../../types/types";
import { useGetAllPlansQuery, useGetAllFeaturesQuery } from "../../services/api/utils.api";
import { useGetPaymentPeriodTypesQuery } from "../../services/api/onboarding.api";

const PlanSelectorStep = ({
  stepNumber,
  values,
  setFieldValue,
  languageId,
}: {
  stepNumber: number;
  values: any;
  setFieldValue: any;
  languageId?: string | null;
}) => {
  const { 
    data: paymentPeriodTypes, 
    isLoading: isLoadingPaymentPeriodTypes, 
    isError: isErrorPaymentPeriodTypes 
  } = useGetPaymentPeriodTypesQuery();
  const { data: plans, isLoading: isPlansLoading } = useGetAllPlansQuery(
    languageId ? { lang: languageId } : undefined,
    {
      skip: stepNumber !== 4 && stepNumber !== 5
    }
  );
  const { data: allFeatures, isLoading: isFeaturesLoading } = useGetAllFeaturesQuery(undefined, {
    skip: stepNumber !== 4 && stepNumber !== 5
  });
  const [showAllPlans, setShowAllPlans] = useState(false);

  // Set default payment period type to Annual (id 2) when payment period types are loaded
  useEffect(() => {
    if (paymentPeriodTypes && paymentPeriodTypes.length > 0) {
      const currentValue = values.paymentsPeriodTypesId;
      // Check if Annual (id 2) exists in the payment period types and value is not set
      const annualPeriod = paymentPeriodTypes.find((ppt) => ppt.id === 2);
      if (annualPeriod && !currentValue) {
        setFieldValue("paymentsPeriodTypesId", 2);
      }
    }
  }, [paymentPeriodTypes, values.paymentsPeriodTypesId, setFieldValue]);

  const handleSelectPlan = (plan: TPlan) => {
    setFieldValue("selectedPlanId", plan.id);
    setShowAllPlans(false);
  };

  const handleShowAllPlans = () => {
    setShowAllPlans(true);
  };

  const handlePaymentPeriodTypeChange = (option: any) => {
    const paymentPeriodTypeId = option?.value;
    setFieldValue("paymentsPeriodTypesId", paymentPeriodTypeId || "");
  };

  const selectedPlan = plans?.find(plan => plan.id.toString() === values.selectedPlanId?.toString());
  const hasSelectedPlan = !!selectedPlan;

  if (stepNumber === 4) {
    return (
      <section className={styles.pricingPreview}>
        {hasSelectedPlan && !showAllPlans ? (
          <section className={styles.selectedContainer}>
            <h3 className={styles.selectedHeader}>{t("YOUR_SELECTED_PLAN")}</h3>
            <PlanCard
              key={selectedPlan.id}
              plan={selectedPlan}
              isSelected={true}
              onSelect={() => handleSelectPlan(selectedPlan)}
              showGetStartedButton={false}
              allFeatures={allFeatures || []}
            />
            <button type="button" className={`${styles.showPlansBtn}`} onClick={handleShowAllPlans}>
              {t("SHOW_ALL_PLAN")}
            </button>
          </section>
        ) : (
          <div className={styles.pricingCards}>
          {isPlansLoading || isFeaturesLoading ? (
            <Loader />
          ) : plans && Array.isArray(plans) && plans.length > 0 ? (
            plans.map((plan) => (
              <PlanCard
                key={plan.id}
                plan={plan}
                isSelected={plan.id.toString() === values.selectedPlanId?.toString()}
                onSelect={() => handleSelectPlan(plan)}
                showGetStartedButton={false}
                allFeatures={allFeatures || []}
              />
            ))
          ) : !isPlansLoading && plans !== undefined ? (
            <div className={styles.noPlans}>
              <p>{t("NO_PLANS_AVAILABLE")}</p>
            </div>
          ) : null
        }
        </div>
        )}

        {/* Payment period types select */}
        {(paymentPeriodTypes && paymentPeriodTypes.length > 0) || isLoadingPaymentPeriodTypes || isErrorPaymentPeriodTypes ? (
          <div className={styles.paymentPeriodContainer}>
            <label className={formStyles.form__label}>{t("PAYMENT_PERIOD_TYPE") || "Payment Period"}</label>
            <Select
              name="paymentsPeriodTypesId"
              value={paymentPeriodTypes?.find((ppt: TPaymentPeriodType) => ppt.id.toString() === values.paymentsPeriodTypesId?.toString()) ? {
                value: values.paymentsPeriodTypesId,
                label: paymentPeriodTypes.find((ppt: TPaymentPeriodType) => ppt.id.toString() === values.paymentsPeriodTypesId?.toString())?.name,
                id: values.paymentsPeriodTypesId
              } : null}
              onChange={handlePaymentPeriodTypeChange}
              options={paymentPeriodTypes?.map((ppt: TPaymentPeriodType) => ({
                value: ppt.id,
                label: ppt.name,
                id: ppt.id
              })) || []}
              placeholder={isErrorPaymentPeriodTypes ? t("ERROR_LOADING_DATA") : (t("ONBOARDING_SELECT") || "Select payment period")}
              isClearable={false}
              isLoading={isLoadingPaymentPeriodTypes}
              isDisabled={isErrorPaymentPeriodTypes}
              className="react-select-container"
              classNamePrefix="react-select"
            />
            {isErrorPaymentPeriodTypes && <p className="error">{t("ERROR_LOADING_PAYMENT_PERIODS")}</p>}
          </div>
        ) : null}

      </section>
    );
  } else if (stepNumber === 5) {
    return (
      <ul className={`${formStyles.form__list} ${formStyles.form__list_type_oneColumn}`}>
        <li className={formStyles.liWide}>
          <label className={formStyles.form__label}>Notes</label>
          <textarea
            value={values.notes}
            onChange={(e) => setFieldValue("notes", e.target.value)}
            className={`${formStyles.form__input} ${formStyles.form__textArea}`}
            placeholder="הערות נוספות..."
          />
        </li>
      </ul>
    );
  }
  return null;
};

export default PlanSelectorStep;
